
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem9ExemptGrid extends Serenity.EntityGrid<PsAdvPromoItem9ExemptRow, any> {
        protected getColumnsKey() { return PsAdvPromoItem9ExemptColumns.columnsKey; }
        protected getDialogType() { return PsAdvPromoItem9ExemptDialog; }
        protected getIdProperty() { return PsAdvPromoItem9ExemptRow.idProperty; }
        protected getInsertPermission() { return PsAdvPromoItem9ExemptRow.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoItem9ExemptRow.localTextPrefix; }
        protected getService() { return PsAdvPromoItem9ExemptService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}